import {actions} from "../actions";
import {mutations} from "../mutations";
import {state} from "../state";
import {stateTransporte} from "../transporte/state";
import {mutationTransporte} from "../transporte/mutation";
import {actionTransporte} from "../transporte/action";

export default {
  mutationTransporte,
  actionTransporte,
  stateTransporte,
  state,
  mutations,
  actions,
}
